// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2M7GQ","footer":"ChangeClinic_footer__2zKT9"};